import { UserProfile } from './datatypes/user-profile';
import { globalState } from './global-state';

export function activeUserProfile(): UserProfile | undefined {
  return globalState().userProfile as UserProfile;
}

export function setActiveUserProfile(userProfile: UserProfile | undefined) {
  globalState().userProfile = userProfile;
}
